export function SignpostImage() {
  return (
    <svg
      width="191"
      height="301"
      viewBox="0 0 191 301"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M190.379 301H3.81451L0 300.653L0.346774 299.96C1.45645 296.631 8.43817 295.798 11.7903 295.798C12.6226 294.134 16.2984 293.718 18.0323 293.718C23.5806 290.389 30.7473 291.637 33.6371 292.677C34.4693 291.29 37.6828 288.863 39.1855 287.822C41.6822 283.939 46.9301 284.124 49.2419 284.702C50.629 284.424 52.8252 285.048 53.75 285.395C61.0322 281.581 64.5 286.435 64.8467 286.435C65.679 281.719 70.5107 279.847 72.8226 279.5C72.8226 278.113 76.2903 276.726 76.6371 276.726C76.9145 276.726 79.9892 277.419 81.4919 277.766L87.3871 279.5L91.8951 279.846C97.4435 278.459 99.7553 280.424 100.218 281.58C102.714 281.303 105.65 282.158 106.806 282.621C110.413 282.344 112.702 283.43 113.395 284.008L117.556 285.048C118.366 285.511 120.053 286.435 120.331 286.435C120.677 286.435 122.411 286.089 125.879 286.435C129.347 286.782 127.96 287.129 129.347 287.129C130.734 287.129 131.081 287.476 133.508 287.129C135.935 286.782 134.548 287.129 136.976 287.129H141.137C142.871 287.129 141.831 286.435 144.258 285.395C144.603 285.247 144.865 285.134 145.061 285.048H144.952C145.427 284.858 145.965 284.652 145.061 285.048H156.395C158.823 285.048 160.903 286.435 161.943 287.129C162.776 287.684 164.833 288.516 165.758 288.863C167.607 290.134 172.347 292.33 176.508 290.943C180.669 289.556 184.253 293.139 185.524 295.104C188.576 295.382 190.032 299.15 190.379 301Z"
        fill="#C0D8E8"
      />
      <path
        d="M80.4515 24.2742V283.661H88.4273V24.2742H80.4515Z"
        fill="url(#paint0_linear_4247_285)"
      />
      <path
        d="M96.7499 14.5645C96.7499 21.4592 91.1607 27.0484 84.266 27.0484C77.3714 27.0484 71.7822 21.4592 71.7822 14.5645C71.7822 7.66986 77.3714 2.08064 84.266 2.08064C91.1607 2.08064 96.7499 7.66986 96.7499 14.5645Z"
        fill="#C0D8E8"
      />
      <path
        d="M98.137 4.85484C98.137 7.53609 95.9634 9.70967 93.2822 9.70967C90.6009 9.70967 88.4273 7.53609 88.4273 4.85484C88.4273 2.17358 90.6009 0 93.2822 0C95.9634 0 98.137 2.17358 98.137 4.85484Z"
        fill="#C0D8E8"
      />
      <path
        d="M80.7983 4.85484C80.7983 7.53609 78.6247 9.70967 75.9435 9.70967C73.2622 9.70967 71.0886 7.53609 71.0886 4.85484C71.0886 2.17358 73.2622 0 75.9435 0C78.6247 0 80.7983 2.17358 80.7983 4.85484Z"
        fill="#C0D8E8"
      />
      <path
        d="M26.9982 101.064L154.167 116.738L154.167 118.115L142.177 134.129L149.19 153.848L149.19 155.234L22.0212 138.183L5.26262 117.043L5.26261 115.655L26.9982 101.064Z"
        fill="#69A0C9"
      />
      <path
        d="M26.9982 99.6773L154.167 116.728L142.177 132.742L149.19 153.847L22.0212 136.797L5.26262 115.656L26.9982 99.6773Z"
        fill="#CFE1EE"
      />
      <path
        d="M26.3552 58.6955L26.3549 56.6277L129.843 38.6087L149.431 48.2827L149.431 50.3495L135.658 68.5657L32.1698 88.6525L32.1698 86.6934L37.1052 71.5726L26.3552 58.6955Z"
        fill="#2C3B45"
      />
      <path
        d="M26.3548 56.6147L129.843 36.5279L149.431 48.2688L135.657 66.485L32.1694 86.5718L37.1048 69.4918L26.3548 56.6147Z"
        fill="#316489"
      />
      <path
        d="M30.3562 169.991L30.9924 168.194L126.51 184.381L140.561 198.82L139.925 200.617L122.344 212.214L26.1909 197.825L26.7939 196.122L35.7387 184.495L30.3562 169.991Z"
        fill="#316489"
      />
      <path
        d="M30.9963 168.182L127.15 182.571L140.565 198.808L122.984 210.405L26.831 196.016L36.3788 182.686L30.9963 168.182Z"
        fill="#69A0C9"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4247_285"
          x1="84.4394"
          y1="24.2742"
          x2="84.4394"
          y2="283.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69A0C9" />
          <stop offset="0.0375701" stopColor="#C0D8E8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
